import { useEffect, useState } from "react";

export default function useLinkTag(href) {
  const [status, setStatus] = useState(href ? "loading" : "idle");

  useEffect(() => {
    if (!href) {
      setStatus("idle");
      return;
    }

    let link = document.querySelector(`link[href="${href}"]`);

    if (!link) {
      link = document.createElement("link");
      link.href = href;
      link.rel = "stylesheet";
      link.type = "text/css";
      link.setAttribute("data-status", "loading");

      document.body.appendChild(link);

      const setAttributeFromEvent = (event) => {
        link.setAttribute(
          "data-status",
          event.type === "load" ? "ready" : "error"
        );
      };

      link.addEventListener("load", setAttributeFromEvent);
      link.addEventListener("error", setAttributeFromEvent);
    } else {
      setStatus(link.getAttribute("data-status"));
    }

    const setStateFromEvent = (event) => {
      setStatus(event.type === "load" ? "ready" : "error");
    };

    link.addEventListener("load", setStateFromEvent);
    link.addEventListener("error", setStateFromEvent);

    return () => {
      if (link) {
        link.removeEventListener("load", setStateFromEvent);
        link.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [href]);

  return status;
}
